import { Card } from '@everlywell/leaves';
import styled from 'styled-components';

export const ProductCard = styled(Card.Product)`
  height: 100%;
`;
